// Shown right after a screen is paired in the dashboard, while we wait for
// the first content payload to arrive. Keeps the player from flashing the
// raw "Waiting for content" or "No content assigned" state during the
// pairing → content handoff. Same visual as LoadingScreen/PublishingLoader
// for consistency — a single "preparing" design across the transition states.
import FrameMarkDraw from './FrameMarkDraw'

export default function PostSetupLoader() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-5 text-center px-10">
      <FrameMarkDraw />
      <p className="text-white text-lg font-medium">We are preparing things for you</p>
    </div>
  )
}
